// @ts-strict-ignore
import {
  ButtonVariant,
  DropdownMenu,
  IconName,
} from '@usealloy/component-library';
import React from 'react';
import { getIconColorForBackgroundColor } from 'flow/editor/components/helpers';
import type { DropdownItem } from './types';
import NodeDropdownItem from './NodeDropdownMenuItem/NodeDropdownMenuItem';
import NodeDropdownMenuTrigger from './NodeDropdownMenuTrigger';


interface NodeDropdownMenuProps {
  backgroundColor?: string;
  label?: string | React.ReactNode;
  dropdownItems: DropdownItem[];
  menuTriggerStyle?: React.CSSProperties;
  onDropdownVisibilityChange?: (checked) => void;
  onTriggerMouseEnter?: React.MouseEventHandler<HTMLButtonElement>;
  onTriggerMouseLeave?: React.MouseEventHandler<HTMLButtonElement>;
}

export default function NodeDropdownMenu({
  backgroundColor,
  label,
  dropdownItems,
  menuTriggerStyle,
  onDropdownVisibilityChange,
  onTriggerMouseEnter,
  onTriggerMouseLeave,
}: NodeDropdownMenuProps) {
  const iconColor = getIconColorForBackgroundColor(backgroundColor);
  const labelShort = label && typeof label === 'string' ? label.slice(0, 10).replace(' ', '-').toLowerCase() : 'default';
  const Trigger = React.useMemo(() => (
    <NodeDropdownMenuTrigger
      data-testid={`node-dropdown-menu-trigger-${labelShort}`}
      data-dd-action-name={`node-dropdown-menu-trigger-${labelShort}`}
      backgroundColor={backgroundColor}
      icon={IconName.More}
      iconColorOverride={iconColor}
      onClick={event => event.stopPropagation()}
      onDoubleClick={event => event.stopPropagation()}
      onMouseEnter={onTriggerMouseEnter}
      onMouseLeave={onTriggerMouseLeave}
      style={{ borderRadius: 2, ...(menuTriggerStyle ?? {}) }}
      variant={ButtonVariant.tertiary}
    />
  ), [
    backgroundColor,
    onTriggerMouseEnter,
    onTriggerMouseLeave,
    iconColor,
    menuTriggerStyle,
    labelShort,
  ]);

  return (
    <DropdownMenu
      onOpenChange={onDropdownVisibilityChange}
      trigger={Trigger}
    >
      {dropdownItems.map(item => (
        <NodeDropdownItem
          disabled={item.disabled}
          key={item.label}
          onSelect={item.onSelect}
          style={item.style}
          dataId={item.dataId}
        >
          {item.Icon && item.Icon}
          {item.label}
        </NodeDropdownItem>
      ))}
    </DropdownMenu>
  );
}
